function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #959595;\n      }\n    "));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "deporte",
  transform: "translate(-473.456 -338.164)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Grupo_96",
  "data-name": "Grupo 96",
  transform: "translate(2 8.4)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Trazado_50",
  "data-name": "Trazado 50",
  className: "cls-1",
  d: "M486.756,329.764a15.3,15.3,0,1,0,15.3,15.3A15.323,15.323,0,0,0,486.756,329.764Zm1,5.5,3.646-2.649a13.351,13.351,0,0,1,5.758,4.18l-1.393,4.289-4.094,1.33-3.917-2.846Zm-5.641-2.648,3.646,2.648v4.305l-3.917,2.846-4.094-1.33-1.393-4.289A13.343,13.343,0,0,1,482.113,332.613ZM475.667,352.4a13.218,13.218,0,0,1-2.186-6.765l3.65-2.653,4.086,1.328,1.5,4.613L480.19,352.4Zm14.643,5.474a12.95,12.95,0,0,1-7.107,0l-1.4-4.3,2.522-3.472h4.857l2.522,3.472Zm3.012-5.474-2.525-3.477,1.5-4.613,4.086-1.329,3.65,2.652a13.219,13.219,0,0,1-2.186,6.766Z"
})));

function SvgDeporte(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.601,
    height: 30.6,
    viewBox: "0 0 30.601 30.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeporte);
export default __webpack_public_path__ + "static/media/deporte.938d9395.svg";
export { ForwardRef as ReactComponent };